import {queryOptions} from '@tanstack/react-query';
import {unwrap} from 'framework';
import type {WorkoutsDependencies} from '../dependencies';
import {keys} from './keys';

/** Muscle list is small and rarely changes during a session. */
export const CATALOG_MUSCLES_STALE_TIME_MS = 30 * 60 * 1000;

export type ListCatalogMusclesQueryDependencies = Pick<WorkoutsDependencies, 'controllers'>;

export const listCatalogMusclesQuery = ({controllers}: ListCatalogMusclesQueryDependencies) =>
  queryOptions({
    queryKey: keys.catalogMuscles.list(),
    queryFn: () => controllers.workoutController.listMuscles().then(unwrap),
    staleTime: CATALOG_MUSCLES_STALE_TIME_MS,
  });
